import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSupabaseAuth } from '../contexts/SupabaseAuthContext';

/**
 * MobileAppHandler - Handles routing for mobile app
 * Bypasses public website and goes straight to login/dashboard
 */
function MobileAppHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, role, loading } = useSupabaseAuth();

  // Check if Capacitor is available (only in mobile app, not web)
  let isMobileApp = false;
  try {
    // Dynamic import to avoid build errors on web
    if (typeof window !== 'undefined' && window.Capacitor) {
      isMobileApp = window.Capacitor.isNativePlatform();
    }
  } catch (error) {
    // Capacitor not available (running on web)
    isMobileApp = false;
  }

  useEffect(() => {
    // Only handle routing for mobile app
    if (!isMobileApp) return;

    // Wait for auth to finish loading
    if (loading) return;

    // Allow these routes in mobile app
    const allowedRoutes = [
      '/login',
      '/auth/callback',
      '/recruiter',
      '/candidate',
      '/client'
    ];

    // Check if current path starts with any allowed route
    const isAllowedRoute = allowedRoutes.some(route =>
      location.pathname.startsWith(route)
    );

    // If not on allowed route, redirect based on auth state
    if (!isAllowedRoute) {
      if (!user) {
        // Not logged in - go to login
        navigate('/login', { replace: true });
      } else if (role) {
        // Logged in - go to appropriate dashboard
        if (role === 'recruiter' || role === 'admin') {
          navigate('/recruiter', { replace: true });
        } else if (role === 'candidate') {
          navigate('/candidate', { replace: true });
        } else if (role === 'client') {
          navigate('/client', { replace: true });
        } else {
          // Unknown role - go to login
          navigate('/login', { replace: true });
        }
      }
    }
  }, [isMobileApp, user, role, loading, location.pathname, navigate]);

  return null;
}

export default MobileAppHandler;
